import { render, staticRenderFns } from "./Rubrique2.vue?vue&type=template&id=fb86b83a&"
import script from "./Rubrique2.vue?vue&type=script&lang=js&"
export * from "./Rubrique2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports